import styled from 'styled-components';

export const Container = styled.div`
  padding: 0 1.5rem;

  & > .hefesto-table-menu {
    margin-bottom: 1rem;

    & .hefesto-table-menu__left {
      text-align: unset;

      & > span.selected-orders {
        font-size: 1rem;
        color: ${({ theme }) => theme.colors.grayDark};
        margin: 0 1rem;
      }
    }
  }
`;
